import React from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Billing = ({ handleBlur, handleChange, values, errors, touched }) => {
  const cc = require("currency-codes");
  const currencies = cc.codes();
  const { t } = useTranslation();

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>{t("crm.newModal.currency")}</Form.Label>
        <Form.Select
          name="currency"
          value={values.currency}
          onBlur={handleBlur}
          onChange={handleChange}
          isInvalid={Boolean(touched.currency && errors.currency)}
        >
          {currencies.map((currency) => (
            <option key={currency} value={currency}>
              {currency}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>{t("crm.newModal.preferredLanguage")}</Form.Label>
        <Form.Select
          name="preferredLanguage"
          value={values.preferredLanguage}
          onBlur={handleBlur}
          onChange={handleChange}
          isInvalid={Boolean(
            touched.preferredLanguage && errors.preferredLanguage
          )}
        >
          <option key="greek" value="greek">
            Greek
          </option>
          <option key="english" value="english">
            English
          </option>
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Billing Email</Form.Label>
        <Form.Control
          type="email"
          name="billingEmail"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.billingEmail}
          isInvalid={Boolean(touched.billingEmail && errors.billingEmail)}
        />
        <Form.Control.Feedback type="invalid">
          {Boolean(touched.billingEmail && errors.billingEmail)}
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
};

export default Billing;
